import React from 'react';

const MinusSymbol = () => {
  return (
    <div className="minus" style={{ focus: '0' }}>
      <svg style={{ margin: '0 0 0.2rem 0' }} width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 0.000364304C5.64175 0.000364304 5.35135 0.000159338 5.35135 0.000159338L0.648649 0C0.290416 0 0 0.2904 0 0.648649C0 1.0069 0.290416 1.2973 0.648649 1.2973H5.35135C5.35135 1.2973 5.64175 1.2973 6 1.2973C6.35825 1.2973 6.64865 1.2973 6.64865 1.2973H11.3514C11.7096 1.2973 12 1.0069 12 0.648649C12 0.2904 11.7096 0 11.3514 0H6.64865C6.64865 0 6.35825 0.000364304 6 0.000364304Z" fill="#101316" />
      </svg>
    </div>
  );
};

export default MinusSymbol;
